import React from 'react';
import Box from '@mui/material/Box';
import CardComp from './CardComp';
import Section from '../components/Section';
import PageHead from './PageHead';
import 'animate.css';

/** 事例一覧ページ（/case, /case/new, /case/reform, /case/office）用のグリッド。 */
const CaseCards = (props) => {
  return (
    <React.Fragment>
      <PageHead eyebrow={props.eyebrow} title={props.title} lead={props.lead} />
      <Section bg="paper" py={0} sx={{ pt: { xs: 8, sm: 12 }, pb: { xs: 10, sm: 15 } }}>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)' },
            gap: { xs: 6, sm: 5 },
          }}
        >
          {props.cards.map((card, index) => (
            <div key={index} className={`animate__custom_delay-${index % 4} ${props.animation}`}>
              <CardComp
                title={card.title}
                message={props.enableMessage === true ? card.message : ''}
                img_path={card.img_path}
                url={card.url}
              />
            </div>
          ))}
        </Box>

        {props.backHref ? (
          <Box sx={{ textAlign: 'center', mt: { xs: 6, sm: 8 } }}>
            <Box
              component="a"
              href={props.backHref}
              sx={{
                fontSize: 14,
                letterSpacing: '.1em',
                color: 'text.secondary',
                textDecoration: 'none',
                borderBottom: (theme) => `1px solid ${theme.palette.line}`,
                pb: 0.5,
                transition: 'color .25s',
                '&:hover': { color: 'green' },
              }}
            >
              ← 事例一覧へ戻る
            </Box>
          </Box>
        ) : null}
      </Section>
    </React.Fragment>
  );
};

export default CaseCards;
